export const maxLicenseCount = 99999;

export function resetLicenseCount(count, minCount) {
    if (!Number.isInteger(count) || count < minCount) {
        return minCount;
    }
    return Math.min(count, Math.max(maxLicenseCount, minCount));
}
